import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { BookingTimeUnavailableContainer } = await import('@containers/Payment/ErrorScreens/BookingTimeUnavailable');
    return {
        Component: BookingTimeUnavailableContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
